import { FC, useEffect, useMemo } from 'react'
import { useCart } from 'hooks'
import { CartValues } from 'modules/cart/components'
import { CartSummaryProps } from '.'

const CartSummary: FC<CartSummaryProps> = ({ row = false, onPage = "cart", hasOnlyExpItems = false }) => {
  const { cartTotal, coupon, shipping, totalShipping, totalItems, selectedSellersDeliveryMethod, itemsToOrder, autoUpdateCartContext } = useCart()

  const total = useMemo(
    () => cartTotal + (totalShipping || 0) - (coupon?.value || 0),
    [cartTotal, coupon, totalShipping],
  )

  useEffect(() => {
    console.log("Atualizou o contexto")
    autoUpdateCartContext();
  }, []);

  return (
    <CartValues
      row={row}
      coupon={coupon?.value || null}
      shipping={shipping}
      total={total}
      cartTotal={cartTotal}
      totalShipping={totalShipping}
      totalItems={itemsToOrder.length}
      onPage={onPage}
      selectedDeliveryKeys={selectedSellersDeliveryMethod}
      hasOnlyExpItems={hasOnlyExpItems}
    />
  )
}

export default CartSummary
